import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function BoardOfDirectors({ boardofDirectors }) {
  const itemRefs = useRef([]);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    itemRefs.current = itemRefs.current.slice(0, boardofDirectors.length);

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setVisibleItems(boardofDirectors.map((_, i) => i));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.getAttribute('data-index'));
          if (entry.isIntersecting) {
            setVisibleItems((prev) => (prev.includes(index) ? prev : [...prev, index]));
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    itemRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [boardofDirectors.length]);

  return (
    <section className="team-member-section pt-5 mt-5" id="board">
      <Container>
        <h3 className="mb-5">Board Of Directors</h3>
        <Row>
          {boardofDirectors?.length === 0 && <p>Loading Board Of Directors...</p>}
          {boardofDirectors?.map((member, index) => (
            <Col
              key={member.id}
              md={12}
              data-index={index}
              ref={(el) => (itemRefs.current[index] = el)}
              className={`animate ${visibleItems.includes(index) ? 'slide-up' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="team-item">
                <Row>
                  <Col md={3} className="text-center">
                    <img className="avatar" src={member.imageUrl} alt={`${member.name} avatar`} />
                    <h4 className="name mt-3 mb-1">{member.name}</h4>
                    <h5 className="position">{member.position}</h5>
                  </Col>
                  <Col md={9}>
                    <div
                      className="mb-0"
                      style={{ lineHeight: '30px' }}
                      dangerouslySetInnerHTML={{ __html: member.description }}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default BoardOfDirectors;
